import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getAPIHandler, postAPIHandler, useBanners } from "../../Api/api";
import MatchInfo from "../../Components/Match Info";
import PitchReport from "../../Components/PitchReport/PitchReport";
import Squads from "../../Components/Squads";
import PointsTable from "../../Components/PointsTable";
import Scoreboard from "../../Components/Scoreboard";
import Commentary from "../../Components/Commentary";
import CircularProgress from "@mui/material/CircularProgress";
import Cricket_Bat from "../../Images/Cricket-Pages/Cricket bat.png";
import Cricket_Bowl from "../../Images/Cricket-Pages/cricket Bowl.png";
import Toss_Coin from "../../Images/Cricket-Pages/toss coin.gif";
import { Helmet } from "react-helmet";
import AdBanner from "../../Components/AdBanner";

const MatchDetails = () => {
  const [matchInfo, setMatchInfo] = useState(null);
  // console.log("matchInfo - ", matchInfo);
  const [liveInfo, setLiveInfo] = useState(null);
  // console.log("liveInfo - ", liveInfo);
  const [infoToggle, setinfoToggle] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  // console.log("isLoading - ", isLoading);
  const [pitchReportToggle, setPitchReportToggle] = useState(false);
  const [squadsToggle, setSquadsToggle] = useState(false);
  const [pointsTableToggle, setPointsTableToggle] = useState(false);
  const [scoreboardToggle, setScoreboardToggle] = useState(false);
  const [commentaryToggle, setCommentaryToggle] = useState(false);
  const [teamScoreCard, setTeamScoreCard] = useState([]);
  const [liveMatchesList, setLiveMatchesList] = useState([]);
  // console.log("liveMatchesList - ", liveMatchesList);
  const [matchStatus, setMatchStatus] = useState();
  // console.log("matchStatus - ", matchStatus);
  const [matchIsLive, setMatchIsLive] = useState(false);
  // console.log("matchIsLive - ", matchIsLive);
  const { matchId, seriesId } = useParams();

  const { horizontal} = useBanners();


  useEffect(() => {
    // Set loading to true initially
    setIsLoading(true);

    // Filter Live Match------------------
    const LiveMatchData =
      liveMatchesList &&
      liveMatchesList.length > 0 &&
      liveMatchesList.filter((match) => {
        return match.match_id == matchId;
      });
    // console.log("LiveMatchData - ", LiveMatchData);

    if (LiveMatchData !== false) {
      if (LiveMatchData && LiveMatchData.length > 0) {
        setMatchIsLive(true);
        setMatchStatus("LIVE");
        setIsLoading(false); // Set loading to false when data is available
      } else {
        setMatchIsLive(false);
        if (liveInfo && !matchIsLive) {
          if (liveInfo.result) {
            setMatchStatus("FINISHED");
          } else {
            setMatchStatus("UPCOMING");
          }
        }
        setIsLoading(false); // Set loading to false when data is available
      }
    }
  }, [liveMatchesList, matchInfo]);

  const handlePointsTable = () => {
    setPointsTableToggle(true);
    setinfoToggle(false);
    setSquadsToggle(false);
    setPitchReportToggle(false);
    setScoreboardToggle(false);
    setCommentaryToggle(false);
  };

  const handleInfo = () => {
    setinfoToggle(true);
    setPointsTableToggle(false);
    setSquadsToggle(false);
    setPitchReportToggle(false);
    setScoreboardToggle(false);
    setCommentaryToggle(false);
  };

  const handleSquadsToggle = () => {
    setSquadsToggle(true);
    setinfoToggle(false);
    setPointsTableToggle(false);
    setPitchReportToggle(false);
    setScoreboardToggle(false);
    setCommentaryToggle(false);
  };

  const handlePitchReportToggle = () => {
    setPitchReportToggle(true);
    setSquadsToggle(false);
    setinfoToggle(false);
    setPointsTableToggle(false);
    setScoreboardToggle(false);
    setCommentaryToggle(false);
  };

  const handleScoreboardToggle = () => {
    setScoreboardToggle(true);
    setPitchReportToggle(false);
    setSquadsToggle(false);
    setinfoToggle(false);
    setPointsTableToggle(false);
    setCommentaryToggle(false);
  };

  const handleCommentaryToggle = () => {
    setCommentaryToggle(true);
    setScoreboardToggle(false);
    setPitchReportToggle(false);
    setSquadsToggle(false);
    setinfoToggle(false);
    setPointsTableToggle(false);
  };

  useEffect(() => {
    GetMatchInfo(matchId);
    GetLiveMatchInfo(matchId);

    const interval = setInterval(() => {
      GetLiveMatchInfo(matchId);
      GetTeamScorecard(matchId);
      GetLiveMatchesList();
    }, 1000);

    return () => clearInterval(interval);
  }, [matchId]);

  // Countdown
  const calculateCountdown = (matchTime) => {
    const now = new Date();
    // const matchDate = new Date(matchInfo.data.match_date);
    const matchDate = new Date(now);
    // console.log("matchDate1 - ", matchDate);

    const [time, modifier] = matchTime.split(" ");
    let [hours, minutes] = time.split(":");
    hours =
      (modifier === "PM" ? parseInt(hours, 10) + 12 : parseInt(hours, 10)) % 24;

    matchDate.setHours(hours);
    matchDate.setMinutes(minutes);
    matchDate.setSeconds(0);

    // console.log("matchDate2 - ", matchDate);
    // console.log("now - ", now);
    const difference = matchDate - now;
    // console.log("difference - ", difference);

    if (difference > 0) {
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    } else {
      if (
        matchInfo.data.result.length === 0 &&
        matchInfo.data.toss.length === 0
      ) {
        return "Details will appear once the match starts.";
      }
    }
  };

  const [countdown, setCountdown] = useState("00:00:00");

  useEffect(() => {
    if (
      matchInfo &&
      matchInfo.data &&
      matchInfo.data.match_time &&
      matchInfo.data.match_date
    ) {
      const timer = setInterval(() => {
        const timeLeft = calculateCountdown(
          matchInfo.data.match_date && matchInfo.data.match_time
        );
        // console.log("timeLeft - ", timeLeft);
        setCountdown(timeLeft);
      }, 1000);

      return () => clearInterval(timer); // Clear the interval on component unmount
    }
  }, [matchInfo]);

  // Match Live Info--------------
  const GetLiveMatchInfo = async (value) => {
    const formData = new FormData();
    formData.append("match_id", value);

    const response = await postAPIHandler("liveMatch", formData);
    // console.log("response-->", response);
    setLiveInfo(response.data);
  };

  // Match Info API-----------------
  const GetMatchInfo = async (value) => {
    const formData = new FormData();
    formData.append("match_id", value);
    const response = await postAPIHandler("matchInfo", formData);
    // console.log("response-->", response);
    setMatchInfo(response);
  };

  const GetTeamScorecard = async (val) => {
    const formData = new FormData();
    formData.append("match_id", val);
    const response = await postAPIHandler("scorecardByMatchId", formData);
    // console.log("scorecardByMatchId resp - ", response);
    setTeamScoreCard(response.data);
  };

  // Match Info API-----------------
  const GetLiveMatchesList = async (value) => {
    const response = await getAPIHandler("liveMatchList");
    // console.log("GetLiveMatchesList response-->", response);
    setLiveMatchesList(response.data);
  };

  const capitalizeSentence = (sentence) => {
    // Split the sentence into words
    const words = sentence.toLowerCase().split(" ");

    // Capitalize each word's first letter
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the words back into a sentence
    return capitalizedWords.join(" ");
  };
  const formatUrl = (url) => {
    const parts = url.split("/"); // Split URL into parts
    const lastPart = parts.pop(); // Get the last part that needs formatting

    const formattedPart = lastPart
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/[^a-z0-9\-]/g, ""); // Remove special characters except "-"

    return [...parts, formattedPart].join("/"); // Rebuild the URL
  };

  return (
    <>
      <Helmet>
        <title>
          Live Scores, Upcoming Matches & Results | cricket betting tips
        </title>
        <meta
          name="description"
          content="Stay updated with cricket betting tips for real-time live scores, upcoming match schedules, and detailed results of completed matches. Your go-to source for all match updates!"
        />
      </Helmet>
      {liveInfo && matchInfo && (
        <div
          key={liveInfo?.match_id}
          className="bg-cover gap-6 pt-20 pb-10 flex flex-col items-center match-info-bg bg-center"
        >
          <h1 className="md:text-[30px] text-white text-center font-[600] md:px-[0] px-[10px]">
            {liveInfo?.team_a_short} vs {liveInfo?.team_b_short},{" "}
            {matchInfo?.data.matchs} <br />
            <span className="text-[18px] text-[#ffffffba]">
              {matchInfo.data.match_type} Match{" "}
              {matchInfo.data.is_hundred === 2 && (
                <span className="text-[14px]">(100 Balls)</span>
              )}
            </span>
          </h1>
          <p>
            {isLoading ? (
              <CircularProgress style={{ color: "#DC9A2B" }} />
            ) : (
              <span
                className={`d-inline-block p-1 py-2 rounded-[6px] blink-button min-w-[100px] text-center font-[600]`}
                style={{
                  background:
                    matchStatus === "LIVE"
                      ? "rgb(58, 185, 73)"
                      : matchStatus === "UPCOMING"
                        ? "blue"
                        : "red",
                }}
              >
                {matchStatus}
              </span>
            )}
          </p>

          {/* Live Card Start */}
          {liveInfo && (
            <div className="bg-[#000000A3] rounded-[12px] lg:w-[45%] w-[90%] md:px-5 px-[20px] py-4 text-center ">
              {/* Team */}
              {liveInfo.batting_team || liveInfo.toss.length === 0 ? (
                <div className="flex justify-between livecard">
                  <div className="space-y-8">
                    <div className="flex items-center gap-2">
                      <img
                        className=" w-[30px] h-[30px] rounded-full object-cover"
                        src={liveInfo.team_a_img}
                        alt=""
                      />
                      <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0">
                        {liveInfo.team_a}
                      </p>
                      {liveInfo.batting_team &&
                        <img
                          className=" w-[20px] h-[20px] rounded-full object-contain"
                          src={liveInfo.batting_team == liveInfo.team_a_id ? Cricket_Bat : Cricket_Bowl}
                          alt="icons"
                        />
                      }
                    </div>
                    <div className="flex items-center gap-2">
                      <img
                        className=" w-[40px] h-[40px] rounded-full object-cover"
                        src={liveInfo.team_b_img}
                        alt=""
                      />
                      <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0">
                        {liveInfo.team_b}
                      </p>
                      {liveInfo.batting_team &&
                        <img
                          className=" w-[20px] h-[20px] rounded-full object-contain"
                          src={liveInfo.batting_team == liveInfo.team_b_id ? Cricket_Bat : Cricket_Bowl}
                          alt=""
                        />
                      }
                    </div>
                  </div>
                  <div className="flex flex-col space-y-8">
                    {/* Team A Score------------ */}
                    <span className="lg:text-[18px] text-[15px] text-white font-[500] mb-0">
                      {liveInfo.team_a_scores ? (
                        liveInfo.team_a_scores_over.map((score, ind) => {
                          return (
                            <span key={ind}>
                              {ind === 1 && <span>&</span>}
                              {score.score + " (" + score.over + ")"}
                            </span>
                          );
                        })
                      ) : (
                        <span className="lg:text-[18px] text-[15px]">
                          No Data
                        </span>
                      )}
                    </span>

                    {/* Team B Score------------ */}
                    <span className="lg:text-[18px] text-[15px] text-white font-[500] mb-0">
                      {liveInfo.team_b_scores ? (
                        liveInfo.team_b_scores_over.map((score, ind) => {
                          return (
                            <span key={ind}>
                              {ind === 1 && <span> & </span>}
                              {score.score + " (" + score.over + ")"}
                            </span>
                          );
                        })
                      ) : (
                        <span className="lg:text-[18px] text-[15px]">
                          No Data
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  {teamScoreCard.length === undefined && (
                    <>
                      {Object.entries(teamScoreCard.scorecard).map(
                        ([groupName, inning], ind) => {
                          return (
                            <div
                              className="flex items-center justify-between gap-2 mb-4 pb-2 scorecard"
                              key={ind}
                            >
                              <div className="flex items-center gap-2">
                                <img
                                  className=" w-[30px] h-[30px] rounded-full object-cover"
                                  src={inning.team.flag}
                                  alt=""
                                />
                                <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0 md:block hidden">
                                  {inning.team.name}
                                </p>
                                <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0 md:hidden block">
                                  {inning.team.short_name}
                                </p>
                              </div>
                              <p className="mb-0">
                                <span className="lg:text-[18px] text-[15px] text-white font-[500] mb-0">
                                  {/* 416-10 (88.3) */}
                                  {inning.team.score +
                                    "-" +
                                    inning.team.wicket +
                                    " (" +
                                    inning.team.over +
                                    ") "}
                                </span>
                              </p>
                            </div>
                          );
                        }
                      )}
                      {/* Super Over */}
                      {teamScoreCard.super_over && (
                        <>
                          <p className="bg-[#a0a0a045] py-1 rounded-md mb-4 text-xl blink-button w-[80%] mx-auto">
                            Super Over
                          </p>
                          {Object.entries(teamScoreCard.super_over).map(
                            ([groupName, inning], ind) => {
                              return (
                                <div
                                  className="flex items-center justify-between gap-2 mb-4 pb-2"
                                  key={ind}
                                >
                                  <div className="flex items-center gap-2">
                                    <img
                                      className=" w-[30px] h-[30px] rounded-full object-cover"
                                      src={inning.team.flag}
                                      alt=""
                                    />
                                    <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0 md:block hidden">
                                      {inning.team.name}
                                    </p>
                                    <p className="lg:text-[22px] text-[15px] text-white font-[500] mb-0 md:hidden block">
                                      {inning.team.short_name}
                                    </p>
                                  </div>
                                  <p className="mb-0">
                                    <span className="lg:text-[18px] text-[15px] text-white font-[500] mb-0">
                                      {/* 416-10 (88.3) */}
                                      {inning.team.score +
                                        "-" +
                                        inning.team.wicket +
                                        " (" +
                                        inning.team.over +
                                        ") "}
                                    </span>
                                  </p>
                                </div>
                              );
                            }
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {/* Team Countdown & Toss & Others*/}
              <div className="lg:text-[18px] text-[15px] text-white font-[500] pt-4">
                <span className="capitalize flex items-center justify-center gap-2">
                  {
                    liveInfo.result?.length > 0 ? (
                      capitalizeSentence(liveInfo.result)
                    ) : liveInfo.trail_lead?.length > 0 ? (
                      capitalizeSentence(liveInfo.trail_lead)
                    ) : liveInfo.first_circle ? (
                      <span
                        className={`
    px-4 py-1 rounded-full
    bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800
    text-gray-100 font-medium
    shadow-md
    animate-[fadeSlide_0.6s_ease-out]
    transition-all duration-500
    ${liveInfo.first_circle?.length > 10 ? 'lg:text-[24px] text-[16px]' : 'text-[42px]'}
  `}
                      >
                        {liveInfo.first_circle}
                      </span>

                    ) : liveInfo.need_run_ball?.length > 0 ? (
                      capitalizeSentence(liveInfo.need_run_ball)
                    ) : liveInfo.toss?.length > 0 ? (
                      <>
                        <img
                          src={Toss_Coin}
                          alt="Toss"
                          className="w-20 h-20 inline-block -mx-5"
                        />
                        {capitalizeSentence(liveInfo.toss)}
                      </>
                    ) : (
                      countdown
                    )
                  }


                </span>
              </div>


              {/* Series Name With Link */}
              <div className="lg:text-[18px] text-[15px] text-white font-[500]  mt-4">
                <Link
                  className="text-decoration-underline text-[#DC9A2B] cursor-pointer blink-button"
                  to={formatUrl(
                    `/series-details/${seriesId}/${matchInfo.data.series}`
                  )}
                >
                  Series Details
                </Link>
              </div>

              {/* Match ANd Series Name  */}
              <div className=" bg-[#a0a0a045] w-full py-2 rounded-md mt-3">
                {matchInfo?.data.matchs}, {matchInfo?.data.place},{" "}
                {matchInfo?.data.match_date}, {matchInfo?.data.series}
              </div>
            </div>
          )}
          {/* Live Card end */}

          <div className="pt-14 space-x-3 lg:w-[100%] sm:w-[700px] mx-auto lg:text-center page-info-tabs">
            <span
              onClick={handleInfo}
              style={{
                backgroundColor: infoToggle ? "#000000A3" : "#00000057",
                borderColor: infoToggle ? "#3AB949" : "#00000057",
                color: infoToggle ? "#3AB949" : "#fff",
              }}
              className="info-hover px-6 py-2 rounded-[32px] cursor-pointer"
            >
              Match Info
            </span>
            <span
              onClick={handleCommentaryToggle}
              style={{
                backgroundColor: commentaryToggle ? "#000000A3" : "#00000057",
                borderColor: commentaryToggle ? "#3AB949" : "#00000057",
                color: commentaryToggle ? "#3AB949" : "#fff",
              }}
              className="info-hover bg-[#00000057]  px-6 py-2 rounded-[32px] text-white hover:text-[#DC9A2B] cursor-pointer  "
            >
              Commentary
            </span>
            <span
              onClick={handleScoreboardToggle}
              style={{
                backgroundColor: scoreboardToggle ? "#000000A3" : "#00000057",
                borderColor: scoreboardToggle ? "#3AB949" : "#00000057",
                color: scoreboardToggle ? "#3AB949" : "#fff",
              }}
              className="info-hover bg-[#00000057]  px-6 py-2 rounded-[32px] text-white hover:text-[#DC9A2B] cursor-pointer  "
            >
              Scorecard
            </span>
            <span
              onClick={handlePitchReportToggle}
              style={{
                backgroundColor: pitchReportToggle ? "#000000A3" : "#00000057",
                borderColor: pitchReportToggle ? "#3AB949" : "#00000057",
                color: pitchReportToggle ? "#3AB949" : "#fff",
              }}
              className="info-hover bg-[#00000057]  px-6 py-2 rounded-[32px] text-white hover:text-[#DC9A2B] cursor-pointer  "
            >
              Pitch Report
            </span>
            <span
              onClick={handleSquadsToggle}
              style={{
                backgroundColor: squadsToggle ? "#000000A3" : "#00000057",
                borderColor: squadsToggle ? "#3AB949" : "#00000057",
                color: squadsToggle ? "#3AB949" : "#fff",
              }}
              className="info-hover bg-[#00000057]  px-6 py-2 rounded-[32px] text-white hover:text-[#DC9A2B] cursor-pointer  "
            >
              Squads
            </span>
            <span
              onClick={handlePointsTable}
              style={{
                backgroundColor: pointsTableToggle ? "#000000A3" : "#00000057",
                borderColor: pointsTableToggle ? "#3AB949" : "#00000057",
                color: pointsTableToggle ? "#3AB949" : "#fff",
              }}
              className={`info-hover bg-[#000]
                hover:bg-[#000000A3] px-6 py-2 rounded-[32px] text-white hover:text-[#DC9A2B] cursor-pointer d-${""}`}
            >
              Points Table
            </span>
          </div>
        </div>
      )}
      <div>{infoToggle && <MatchInfo status={matchStatus} />}</div>
      <div>{pitchReportToggle && <PitchReport />}</div>
      <div>{squadsToggle && <Squads />}</div>
      <div>{pointsTableToggle && <PointsTable seriesId={seriesId} />}</div>
      <div>{scoreboardToggle && <Scoreboard />}</div>
      <div>{commentaryToggle && <Commentary status={matchStatus} />}</div>

      {/* ==========Advertisement============== */}
     <AdBanner data={horizontal} type="horizontal" />
    </>
  );
};

export default MatchDetails;
